const VERSION = '2.0.20a'
export default VERSION
